import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';
import { AppConstants } from '../app-constants';
import { Observable, Subject } from 'rxjs';
import { HttpRequest } from '@angular/common/http';
import { ApisService } from './apis.service';
import { EncryptDecryptUtil } from './encryption.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private requests: HttpRequest<any>[] = [];
  keySize = 256;
  iterations = 100;
  secretkeyVal: string = '';
  secretKeySubject = new Subject<any>();
  constructor(private apis: ApisService, protected encryptDecrypt: EncryptDecryptUtil) {
    this.getSecretKey().subscribe((seckey) => {
      this.secretkeyVal = seckey;
    });
  }
  apis_encrypt(body: any) {
      if (environment.encryptDecrypt) {
            const encryptBody = this.encryptDecrypt.encrypt(JSON.stringify(body));
            return {
                body: encryptBody
            };
        }
        return body;
  }
  apis_decrypt(response: any) {
    if (environment.encryptDecrypt) {
      return JSON.parse(this.encryptDecrypt.decrypt(response.result));
    }
    return response;
  }
  /**
 * Retrieves a session value by key, decrypts it, and parses it if available.
 * @param key - The session key to retrieve.
 * @returns The parsed value from sessionStorage, or null/undefined if not found.
 */
  getSession(key: string) {
    // Get the stored value from sessionStorage
    let value = sessionStorage.getItem(key);
    if (!value || value == null || value == undefined) return value;
    return JSON.parse(this.decryptValue(value));
  }

  /**
 * Stores a value in sessionStorage after encryption.
 * Converts objects to JSON strings before encryption.
 * @param key - The session key under which the value is stored.
 * @param value - The value to store; can be string, number, boolean, or object.
 */
  setSession(key: string, value: any) {
    if (typeof (value) != 'string' && typeof (value) != 'boolean' && typeof (value) != 'number') {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, this.encryptValue(value));
  }

  /**
 * Removes a key-value pair from sessionStorage.
 * @param key - The session key to remove.
 */
  removeSession(key: string) {
    sessionStorage.removeItem(key);
  }

  getSecretKey(): Observable<string> {
    return this.secretKeySubject.asObservable();
  }
  setSecretkey(seckey: string) {
    this.secretKeySubject.next(seckey);
  }
  encryptValue(data: any) {
    let secretkey = this.secretkeyVal;
    console.log(secretkey, 'secretkey')
    let encrypted = crypto.AES.encrypt(
      data,
      crypto.enc.Utf8.parse(secretkey),
      {
        keySize: 16,
        iv: crypto.enc.Utf8.parse(secretkey),
        mode: crypto.mode.CBC, // ECB,
        padding: crypto.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  }

  decryptValue(encryptedData: any) {
    let secretkey = this.secretkeyVal;
    let decrypted = crypto.AES.decrypt(
      encryptedData,
      crypto.enc.Utf8.parse(secretkey),
      {
        keySize: 16,
        iv: crypto.enc.Utf8.parse(secretkey),
        mode: crypto.mode.CBC,
        padding: crypto.pad.Pkcs7,
      }
    ).toString(crypto.enc.Utf8);
    return decrypted;
  }

  showErrorToaster(error: any) {
    let message = this.getErrorMessage(error);
    console.log('app error: ', message);
    // this.toasterService.error('', message);
  }

  getErrorMessage(error: any) {
    let message = null;
    if (error && error.error && error.error.message) {
      return error.error.message;
    } else if (error && error.error) {
      message = this.getDecryptedMessage(error.error);
      return message || error.error;
    } else {
      message = this.getDecryptedMessage(error);
      return message || error;
    }
  }
  getDecryptedMessage(error: any) {
    let result = ''
    return result ? result : null;
  }
addRequest(req: HttpRequest<any>) {
  this.requests.push(req);
  this.apis.loadingSubject.next(true);
}

removeRequest(req: HttpRequest<any>) {
  const index = this.requests.indexOf(req);
  if (index >= 0) {
    this.requests.splice(index, 1);
  }
  this.apis.loadingSubject.next(this.requests.length > 0);
}
}
